import { Menu, TextField, List, ListItemButton, ListItemText, Chip } from '@mui/material';
import { FC, useState, useEffect, MouseEvent, useCallback, memo } from 'react';

export type SelectDriverMenuDriverEntity = {
  id: number;
  name: string;
  temporary: boolean;
}

type Props = {
  anchorEl: HTMLElement | null;
  onClose: (event: MouseEvent) => void;
  onDriverClick: (event: MouseEvent, id: number, name: string) => void;
  driverData: SelectDriverMenuDriverEntity[];
  driverIdsHasDelivery: number[];
  isTemporaryDriver: boolean;
};

const SelectDriverMenuPresenter: FC<Props> = memo(({
  anchorEl,
  onClose,
  onDriverClick,
  driverData,
  driverIdsHasDelivery,
  isTemporaryDriver,
}) => {
  const [searchDriverInputValue, setSearchDriverInputValue] = useState('');
  const [searchDriverQuery, setSearchDriverQuery] = useState<string>('');
  const [isComposing, setIsComposing] = useState(false);

  const handleDriverSearchQueryChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setSearchDriverInputValue(event.target.value);
  }, []);

  useEffect(() => {
    if (isComposing) return;
    setSearchDriverQuery(searchDriverInputValue);
  }, [isComposing, searchDriverInputValue]);

  const filteredDrivers = driverData?.filter((it) => !it.temporary && it.name.toLowerCase().includes(searchDriverQuery?.toLowerCase())) ?? [];

  const noPlan = <Chip color="error" size="small" label="計画無" />;

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      sx={{ maxHeight: 500 }}
      PaperProps={{
        style: { padding: 0, margin: 0 }
      }}
    >
      <TextField
        fullWidth
        variant="outlined"
        size="small"
        placeholder="検索"
        value={searchDriverInputValue}
        onChange={handleDriverSearchQueryChange}
        onCompositionStart={() => setIsComposing(true)}
        onCompositionEnd={() => setIsComposing(false)}
      />
      <List sx={{ p: 0, m: 0 }}>
        {!isTemporaryDriver && (
          <ListItemButton
            key={['it', -1].join('-')}
            onClick={(event) => onDriverClick(event, -1, '指定なし')}
            sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}
          >
            <ListItemText
              primary="指定なし"
              primaryTypographyProps={{ fontSize: 14, color: 'black' }}
            />
          </ListItemButton>
        )}
        {filteredDrivers.map((it) => (
          <ListItemButton
            key={['it', it.id].join('-')}
            onClick={(event) => onDriverClick(event, it.id, it.name)}
            sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}
          >
            <ListItemText
              primary={it.name}
              primaryTypographyProps={{ fontSize: 14, color: 'black' }}
            />
            {!driverIdsHasDelivery.includes(it.id) && noPlan}
          </ListItemButton>
        ))}
      </List>
    </Menu>
  );
});

export default SelectDriverMenuPresenter;
